import { useTranslation } from 'react-i18next';
import { File, Download } from 'lucide-react';
import { toast } from 'react-hot-toast';
import { useMessageAttachments } from '@/hooks/useMessageAttachments';
import { useGetDocumentDownloadUrl } from '@/hooks/useDocuments';

export function MessageAttachments({ messageId }: { messageId: string }) {
  const { t } = useTranslation();
  const { data: attachments, isLoading } = useMessageAttachments(messageId);
  const getDownloadUrl = useGetDocumentDownloadUrl();

  const handleDownload = async (documentId: string, filename: string) => {
    try {
      const url = await getDownloadUrl.mutateAsync(documentId);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      console.error('Error downloading attachment:', err);
      toast.error(t('documents.errors.download_failed', 'Kunne ikke downloade fil'));
    }
  };

  if (isLoading || !attachments || attachments.length === 0) {
    return null;
  }

  return (
    <div className="mt-2 space-y-1">
      {attachments.map((attachment) => (
        <button
          key={attachment.id}
          type="button"
          onClick={() => handleDownload(attachment.document_id, attachment.document.original_filename)}
          disabled={getDownloadUrl.isPending}
          className="flex items-center gap-2 rounded-md bg-ds-sunk px-3 py-2 text-sm text-ds-text hover:bg-ds-neutral-tint disabled:opacity-50"
        >
          <File className="h-4 w-4 flex-shrink-0" />
          <span className="truncate">{attachment.document.original_filename}</span>
          <Download className="h-3 w-3 flex-shrink-0 ml-auto" />
        </button>
      ))}
    </div>
  );
}
